import { cva } from "class-variance-authority";
import React, { memo } from "react";

import { cn } from "@/lib/chillnn/cn";

import type { VariantProps } from "class-variance-authority";

const labelVariants = cva("inline-flex min-w-[40px] items-center justify-center rounded text-xs", {
	variants: {
		variant: {
			required: "bg-error-200 text-error-600",
			green: "bg-green-200 text-green-600",
			black: "bg-zinc-200 text-zinc-600",
			pink: "bg-pink-200 text-pink-600",
			purple: "bg-purple-200 text-purple-600",
			blue: "bg-blue-200 text-blue-600",
			link: "bg-link-200 text-link-600",
			circle: "size-6 rounded-full min-w-6 bg-pink-200 font-normal text-pink-600",
		},
		size: {
			default: "px-3 py-1.5",
			xs: "px-2 py-1 text-2xs",
			sm: "px-2 py-1 text-xs",
			lg: "px-4 py-2.5 text-sm",
			xl: "px-8 py-3 text-base",
		},
	},
	defaultVariants: {
		variant: "required",
		size: "default",
	},
});

export interface LabelProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof labelVariants> {
	text: string;
}

const Label = memo(
	React.forwardRef<HTMLSpanElement, LabelProps>(({ className, variant, size, ...props }, ref) => {
		const { text } = props;

		return (
			<span
				className={cn(
					labelVariants({
						variant,
						size,
						className,
					}),
				)}
				ref={ref}
				{...props}
			>
				{text}
			</span>
		);
	}),
);
Label.displayName = "Label";

export { Label, labelVariants };
